import { EventEmitter } from "events"

import dispatcher from "../dispatcher"
import hierarchySettingsStore from "./HierarchySettingsStore"
import moment from "moment"

class UserStore extends EventEmitter {
    FetchingUserDetail = false
    //Users = new Array()
    UserStatsFaceSpaces = 0
    UserStatsRecords = 0
    UserStatsExceptions = 0
    I9Users = new Array()
    I9UsersTotal = 0
    leaveTrackingStateFilter = {
        Requested: true,
        Approved: true,
        Denied: true
    }
    leaveTrackingDateFilter = {
        StartDate: moment().utc(true).startOf("year").format(),
        EndDate: moment().utc(true).endOf("year").format(),
    }
    leaveTrackingSearchText = ""
    leaveTrackingLimit = 20
    leaveTrackingOffset = 0
    leaveTrackingLimitOption = [20, 50, 100]

    requireAddNewLeaveTracking = false
    reloadSelfServiceLeaveDashboard = false
    holidays = []

    userStatsTodayHours = 0
    userStatsThisWeekHours = 0
    CurrentUserDetail = null
    constructor() {
        super()
        this.setMaxListeners(0)
    }

    getRequireAddNewLeaveTracking() {
        return this.requireAddNewLeaveTracking
    }

    setRequireAddNewLeaveTracking(value) {
        this.requireAddNewLeaveTracking = value
        this.emit("change_require_add_new_leave_tracking")
    }

    getReloadSelfServiceLeaveDashboard() {
        return this.reloadSelfServiceLeaveDashboard
    }

    setReloadSelfServiceLeaveDashboard(value) {
        this.reloadSelfServiceLeaveDashboard = value
        this.emit("change_reload_self_service_leave_dashboard")
    }

    getCurrentUserDetail() {
        return this.CurrentUserDetail
    }

    getUserStatsFaceSpaces() {
        return this.UserStatsFaceSpaces
    }

    getUserStatsRecords() {
        return this.UserStatsRecords
    }

    getUserStatsTodayHours() {
        return this.userStatsTodayHours
    }

    getUserStatsThisWeekHours() {
        return this.userStatsThisWeekHours
    }

    getUserStatsExceptions() {
        return this.UserStatsExceptions
    }

    clearCurrentUserDetail() {
        this.CurrentUserDetail = null
        this.FetchingUserDetail = true
    }

    getI9Users() {
        return this.I9Users
    }

    isFetchingUserDetail() {
        return this.FetchingUserDetail
    }

    receivedI9Users(data) {
        this.I9Users = data.Documents
        this.I9UsersTotal = data.TotalDocumentCount
        this.emit("change")
    }

    updatingUserProfilePic() {
        this.FetchingUserDetail = true
        this.emit("change")
    }

    fetchUserDetail(userId) {
        this.CurrentUserDetail = null
        this.FetchingUserDetail = true
        this.emit("change")
    }

    recieveUserDetail(user) {
        if (!user.Punches) {
            user.Punches = new Array()
        }

        this.CurrentUserDetail = user
        this.userStatsTodayHours = 0
        this.userStatsThisWeekHours = 0
        this.FetchingUserDetail = false
        this.emit("change")
    }

    receiveUserStats(stats) {
        this.UserStatsFaceSpaces = stats.TotalFaceSpaces
        this.UserStatsRecords = stats.TotalRecords
        this.UserStatsExceptions = stats.TotalExceptions
        this.emit("change")
    }

    setUserStatsHours(stats) {
        this.userStatsTodayHours = stats.DailyHours
        this.userStatsThisWeekHours = stats.WeeklyHours
        this.emit("change")
    }

    updateHierarchyUsers(users) {
        const currentHierarchyLevelId = hierarchySettingsStore.getGlobalHierarchyLevelIdCookie()
        if (!currentHierarchyLevelId) return users
        const filteredWithHierarchy = users.filter(
            (u) =>
                u.HierarchyList
                    ? u.HierarchyList.some((hierarchyId, i, arr) => {
                        return hierarchyId === currentHierarchyLevelId
                    })
                    : null
        )
        return filteredWithHierarchy
    }

    getLeaveTrackingStateFilter() {
        return this.leaveTrackingStateFilter
    }

    getLeaveTrackingDateFilter() {
        return this.leaveTrackingDateFilter
    }

    getLeaveTrackingOffset() {
        return this.leaveTrackingOffset
    }

    getLeaveTrackingLimit() {
        return this.leaveTrackingLimit
    }

    getLeaveTrackingLimitOption() {
        return this.leaveTrackingLimitOption
    }

    getLeaveTrackingSearchText() {
        return this.leaveTrackingSearchText
    }

    setLeaveTrackingStateFilter(data) {
        this.leaveTrackingStateFilter = data
        this.leaveTrackingOffset = 0
        this.emit("change")
    }

    setLeaveTrackingDateFilter(data) {
        this.leaveTrackingDateFilter = data
        this.leaveTrackingOffset = 0
        this.emit("change")
    }

    setLeaveTrackingOffset(offset) {
        this.leaveTrackingOffset = offset
        this.emit("change")
    }

    setLeaveTrackingLimit(limit) {
        this.leaveTrackingLimit = limit
        this.leaveTrackingOffset = 0
        this.emit("change")
    }

    setLeaveTrackingSearchText(searchText) {
        this.leaveTrackingSearchText = searchText
        this.leaveTrackingOffset = 0
        this.emit("change")
    }

    setHolidays(holidays) {
        this.holidays = holidays
        this.emit("change")
    }

    getHolidays() {
        return this.holidays
    }

    updatePayrollSettings() {
        this.emit("change_payroll_setting")
    }

    handleActions(action) {
        switch (action.type) {
            case "REQUIRE_ADD_NEW_LEAVE_TRACKING": {
                this.setRequireAddNewLeaveTracking(action.data)
                break
            }
            case "RELOAD_SELF_SERVICE_LEAVE_DASHBOARD": {
                this.setReloadSelfServiceLeaveDashboard(action.data)
                break
            }
            case "RECEIVE_I9_USERS": {
                this.receivedI9Users(action.data)
                break
            }
            case "UPDATING_USER_PROFILE_PIC": {
                this.updatingUserProfilePic()
                break
            }
            case "FETCH_USER_DETAILS": {
                this.fetchUserDetail(action.userId)
                break
            }
            case "RECEIVE_USER_DETAIL": {
                this.recieveUserDetail(action.user)
                break
            }
            case "RECEIVE_USER_STATS": {
                this.receiveUserStats(action.stats)
                break
            }
            case "SET_USER_STATS_HOURS": {
                this.setUserStatsHours(action.stats)
                break
            }
            case "UPDATE_EMPLOYEE_LEAVE_TRACKING_STATE_FILTER": {
                this.setLeaveTrackingStateFilter(action.data)
                break
            }
            case "UPDATE_EMPLOYEE_LEAVE_TRACKING_DATE_FILTER": {
                this.setLeaveTrackingDateFilter(action.data)
                break
            }
            case "UPDATE_EMPLOYEE_LEAVE_TRACKING_OFFSET": {
                this.setLeaveTrackingOffset(action.data)
                break
            }
            case "UPDATE_EMPLOYEE_LEAVE_TRACKING_LIMIT": {
                this.setLeaveTrackingLimit(action.data)
                break
            }
            case "UPDATE_EMPLOYEE_LEAVE_TRACKING_SEARCH": {
                this.setLeaveTrackingSearchText(action.data)
                break
            }
            case "UPDATE_EMPLOYEE_HOLIDAYS": {
                this.setHolidays(action.data)
                break
            }
            case "UPDATE_PAYROLL_SETTINGS": {
                this.updatePayrollSettings()
                break
            }
        }
    }
}

const userStore = new UserStore()
dispatcher.register(userStore.handleActions.bind(userStore))

export default userStore
